import React, { useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb2"
import { Card, CardBody, Container, Row, Col, Label } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useParams } from "react-router-dom"
import LoadingComponent from "components/Loading/LoadingComponent"
import { OtherCustomerAction } from "store/customer-resource/actions"
import TableContainer from "components/tables/TableContainer"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import { MetaTags } from "react-meta-tags"
import Select from "react-select"
import moment from "moment"
import { get } from "helpers/api_helper"
import DateInput from "components/Common/DateInput"
import { OtherCustomerAPI } from "helpers/customer_backend_helper"

export default function IndividualCustomerManagementhistory() {
  const dispatch = useDispatch()
  const history = useHistory()
  const urlParams = useParams()
  const store = useSelector(state => state)

  const [params, setParams] = React.useState({
    page: 1,
    size: 10,
  })
  const [filter, setFilter] = React.useState({
    supplierName: "",
    storeName: "",
    type: "",
    productId: "",
    productName: "",
    orderDateFrom: "",
    orderDateTo: "",
    scheduledDeliveryDateFrom: "",
    scheduledDeliveryDateTo: "",
    deliveryDateFrom: "",
    deliveryDateTo: "",
  })

  const [optionProduct, setOptionProduct] = useState([])

  React.useEffect(() => {
    dispatch(
      OtherCustomerAction.getListHistoryPage({ id: urlParams.id, ...params })
    )
  }, [params])

  React.useEffect(() => {
    const getListProduct = async () => {
      const res = await get("admin/master/product/list")

      const temp = []
      res.data.map(m => {
        temp.push({ label: m.productName, value: m.id })
      })

      setOptionProduct(temp)
    }
    getListProduct()
  }, [])

  const columns = React.useMemo(
    () => [
      {
        Header: "取引先",
        accessor: "supplierName",
        disableSortBy: true,
      },
      {
        Header: "店舗",
        accessor: "storeName",
        disableSortBy: true,
      },
      {
        Header: "受注番号",
        accessor: "orderNumber",
        disableSortBy: true,
      },
      {
        Header: "ステータス",
        accessor: "status",
        disableSortBy: true,
      },
      {
        Header: "顧客名",
        accessor: "customerName",
        disableSortBy: true,
      },
      {
        Header: "区分",
        accessor: "type",
        disableSortBy: true,
      },
      {
        Header: "商品",
        accessor: "productName",
        disableSortBy: true,
      },
      {
        Header: "受注日",
        accessor: "orderDate",
        disableSortBy: true,
      },
      {
        Header: "生地商社",
        accessor: "fabricCompanyName",
        disableSortBy: true,
      },
      {
        Header: "生地番号",
        accessor: "fabricNumber",
        disableSortBy: true,
      },
      {
        Header: "生地単価",
        accessor: "unitPrice",
        disableSortBy: true,
      },
      {
        Header: "用尺",
        accessor: "scale",
        disableSortBy: true,
      },
      {
        Header: "生地代",
        accessor: "fabricCost",
        disableSortBy: true,
      },
      {
        Header: "上代",
        accessor: "ancientTimes",
        disableSortBy: true,
      },
      {
        Header: "粗利",
        accessor: "grossProfit",
        disableSortBy: true,
      },
      {
        Header: "納品日",
        accessor: "deliveryDate",
        disableSortBy: true,
      },
      {
        Header: "支払いステータス",
        accessor: "paymentStatus",
        disableSortBy: true,
      },
      // {
      //   Header: "コード",
      //   accessor: "fullCode",
      //   disableSortBy: true,

      //   Cell: ({ cell }) => {
      //     return (
      //       <div
      //         role="button"
      //         className="text-primary"
      //         style={{ cursor: "pointer" }}
      //         onClick={() =>
      //           history.push(
      //             `/direct-management-individual-customer-management/${cell.row.original.id}`
      //           )
      //         }
      //       >
      //         {cell.row.original.fullCode}
      //       </div>
      //     )
      //   },
      // },
    ],
    []
  )

  const onChangeFilter = e => {
    const { name, value } = e.target
    setFilter({
      ...filter,
      [name]: value,
    })
  }

  const downLoadCsv = async params => {
    try {
      const { data } = await OtherCustomerAPI.getCSVDataApi(params.id, params)
      const link = document.createElement("a")
      link.href = URL.createObjectURL(
        new Blob([data], { type: "text/csv;charset=utf-8;" })
      )
      link.setAttribute(
        "download",
        "report-history" + new Date().getTime() + ".csv"
      )
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <MetaTags>
        <title>直営個人顧客管理 | Igarashi Trousers</title>
      </MetaTags>

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"直営個人顧客管理"} breadcrumbItems={[]} />

          <Card>
            <CardBody>
              <Row>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"取引先"}
                    placeholder={""}
                    type="text"
                    name="supplierName"
                    onChange={onChangeFilter}
                    value={filter.supplierName}
                  />
                </Col>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"店舗"}
                    placeholder={""}
                    type="text"
                    name="storeName"
                    onChange={onChangeFilter}
                    value={filter.storeName}
                  />
                </Col>
                <Col lg={2}>
                  <Label>区分</Label>
                  <Select
                    options={[
                      {
                        value: "Bespoke",
                        label: "Bespoke",
                      },
                      {
                        value: "MTM",
                        label: "MTM",
                      },
                    ]}
                    defaultValue={{
                      value: filter.type,
                      label: filter.type,
                    }}
                    value={{
                      value: filter.type,
                      label: filter.type,
                    }}
                    isClearable
                    onChange={e => {
                      if (e) {
                        setFilter({ ...filter, type: e.value })
                      } else {
                        setFilter({ ...filter, type: "" })
                      }
                    }}
                  />
                </Col>
                <Col lg={2}>
                  <Label>商品</Label>
                  <Select
                    options={optionProduct}
                    defaultValue={{
                      value: filter.productId,
                      label: filter.productName,
                    }}
                    value={{
                      value: filter.productId,
                      label: filter.productName,
                    }}
                    isClearable
                    onChange={e => {
                      if (e) {
                        setFilter({
                          ...filter,
                          productId: e.value,
                          productName: e.label,
                        })
                      } else {
                        setFilter({ ...filter, productId: "", productName: "" })
                      }
                    }}
                  />
                </Col>
                <Col lg={2} className="align-self-end">
                  <SButton
                    onClick={() => {
                      dispatch(
                        OtherCustomerAction.getListHistoryPage({
                          id: urlParams.id,
                          ...params,
                          ...filter,
                          ...{
                            ...(filter.scheduledDeliveryDateFrom && {
                              scheduledDeliveryDateFrom: moment(
                                filter.scheduledDeliveryDateFrom
                              ).format("YYYY-MM-DD"),
                            }),
                          },
                          ...{
                            ...(filter.scheduledDeliveryDateTo && {
                              scheduledDeliveryDateTo: moment(
                                filter.scheduledDeliveryDateTo
                              ).format("YYYY-MM-DD"),
                            }),
                          },
                          ...{
                            ...(filter.orderDateFrom && {
                              orderDateFrom: moment(
                                filter.orderDateFrom
                              ).format("YYYY-MM-DD"),
                            }),
                          },
                          ...{
                            ...(filter.orderDateTo && {
                              orderDateTo: moment(filter.orderDateTo).format(
                                "YYYY-MM-DD"
                              ),
                            }),
                          },
                          ...{
                            ...(filter.deliveryDateFrom && {
                              deliveryDateFrom: moment(
                                filter.deliveryDateFrom
                              ).format("YYYY-MM-DD"),
                            }),
                          },
                          ...{
                            ...(filter.deliveryDateTo && {
                              deliveryDateTo: moment(
                                filter.deliveryDateTo
                              ).format("YYYY-MM-DD"),
                            }),
                          },
                        })
                      )
                    }}
                    className="button me-1"
                  >
                    検索
                  </SButton>
                  <SButton
                    onClick={() => {
                      downLoadCsv({
                        id: urlParams.id,
                        ...params,
                        ...filter,
                        ...{
                          ...(filter.scheduledDeliveryDateFrom && {
                            scheduledDeliveryDateFrom: moment(
                              filter.scheduledDeliveryDateFrom
                            ).format("YYYY-MM-DD"),
                          }),
                        },
                        ...{
                          ...(filter.scheduledDeliveryDateTo && {
                            scheduledDeliveryDateTo: moment(
                              filter.scheduledDeliveryDateTo
                            ).format("YYYY-MM-DD"),
                          }),
                        },
                        ...{
                          ...(filter.orderDateFrom && {
                            orderDateFrom: moment(filter.orderDateFrom).format(
                              "YYYY-MM-DD"
                            ),
                          }),
                        },
                        ...{
                          ...(filter.orderDateTo && {
                            orderDateTo: moment(filter.orderDateTo).format(
                              "YYYY-MM-DD"
                            ),
                          }),
                        },
                        ...{
                          ...(filter.deliveryDateFrom && {
                            deliveryDateFrom: moment(
                              filter.deliveryDateFrom
                            ).format("YYYY-MM-DD"),
                          }),
                        },
                        ...{
                          ...(filter.deliveryDateTo && {
                            deliveryDateTo: moment(
                              filter.deliveryDateTo
                            ).format("YYYY-MM-DD"),
                          }),
                        },
                      })
                    }}
                    className="button"
                  >
                    CSV出力
                  </SButton>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col lg={4}>
                  <Label>受注日</Label>
                  <div className="d-flex gap-2 align-items-center">
                    <DateInput
                      className="form-control"
                      onChange={date =>
                        setFilter({ ...filter, orderDateFrom: date })
                      }
                    />
                    <span>~</span>
                    <DateInput
                      className="form-control"
                      onChange={date =>
                        setFilter({ ...filter, orderDateTo: date })
                      }
                    />
                  </div>
                </Col>
                <Col lg={4}>
                  <Label>納品予定日</Label>
                  <div className="d-flex gap-2 align-items-center">
                    <DateInput
                      className="form-control"
                      onChange={date =>
                        setFilter({
                          ...filter,
                          scheduledDeliveryDateFrom: date,
                        })
                      }
                    />
                    <span>~</span>
                    <DateInput
                      className="form-control"
                      onChange={date =>
                        setFilter({ ...filter, scheduledDeliveryDateTo: date })
                      }
                    />
                  </div>
                </Col>
                <Col lg={4}>
                  <Label>納品日</Label>
                  <div className="d-flex gap-2 align-items-center">
                    <DateInput
                      className="form-control"
                      onChange={date =>
                        setFilter({
                          ...filter,
                          deliveryDateFrom: date,
                        })
                      }
                    />
                    <span>~</span>
                    <DateInput
                      className="form-control"
                      onChange={date =>
                        setFilter({ ...filter, deliveryDateTo: date })
                      }
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Row className="mb-2">
                {store.customer.otherHistory.loading ? (
                  <LoadingComponent />
                ) : (
                  <TableContainer
                    data={store.customer.otherHistory.data?.content || []}
                    columns={columns}
                    pagination
                    page={params.page}
                    size={params.size}
                    count={store.customer.otherHistory.data?.totalPages || 1}
                    setPageSize={size => setParams({ ...params, size })}
                    setParams={page => setParams({ ...params, page })}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
